import { Info, Language } from '@audio-network/componentlibrary/icons'

import Help from '../Help/Help'
import LanguageSelector from '../LanguageSelector/LanguageSelector'
import SidebarNav from '../SidebarNav/SidebarNav'
import SidebarNavItem from '../SidebarNavItem/SidebarNavItem'
import { languages } from '../LanguageSelector/LanguageSelector.constants'
import styles from './FurtherInfo.module.css'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

const FurtherInfo = (): JSX.Element => {
	const { t } = useTranslation(['navigation'])
	const { locale } = useRouter()

	return (
		<SidebarNav className={styles.furtherInfo} aria-label={t('further-info')}>
			<SidebarNavItem
				startIcon={<Info />}
				content={t('help')}
				popovertarget="sidebar-help"
			/>
			<Help className={styles.popover} id="sidebar-help" />
			<SidebarNavItem
				aria-label={t('choose-language')}
				startIcon={<Language />}
				content={
					languages.find((language) => language.locale === locale)?.language
				}
				popovertarget="language"
			/>
			<LanguageSelector className={styles.popover} id="language" />
		</SidebarNav>
	)
}

export default FurtherInfo
